import { StyledStatusBox } from "./statusBox.style";
import { StatusBoxProp } from "./types/statusBoxProp";

export const StatusBox = ({ status }: StatusBoxProp) => {
    return <StyledStatusBox status={status}></StyledStatusBox>;
};
